import {NumericTextBox,
    NumericTextBoxBlurEvent, NumericTextBoxProps
} from "@progress/kendo-react-inputs";
import React, {
    KeyboardEventHandler,
    ReactNode,
    useState
} from "react";
import "./FlintTextBox.scss"
import {CustomComponent} from "@progress/kendo-react-common";
import {Error} from "@progress/kendo-react-labels";

export default function FlintNumericTextBox(props: flintNumericTextBoxProps) {
    const [visited, setVisited] = useState(false);
    const {onEnterPressed, validationData, wrappedSuffix, suffix, ...other} = props;
    const ntbSuffix : CustomComponent<any> | undefined = wrappedSuffix ? ()=><span className={"me-2"}>{wrappedSuffix}</span> : props.suffix;
    const handleBlur = (event: NumericTextBoxBlurEvent) => {
        setVisited(true);
        validationData?.validateFunction?.(validationData?.optionalObjectToValidate).catch((err) => {
        });
        if (props.onBlur) {
            props.onBlur(event); // Call the parent's onBlur handler if provided
        }
    };

    const handleKeyUp = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (props.onEnterPressed && event.key === 'Enter') {
            event.stopPropagation();
            props.onEnterPressed(event); // Call the onEnterPressed handler
        }
        if (props.onKeyUp) {
            props.onKeyUp(event); // Call the parent's onKeyUp handler if provided
        }
    };
    return (<div className="flint-numeric-text-box">
        <NumericTextBox{...other}
                       suffix={ntbSuffix}
            // prefix={() => suffix ? <>{prefix}</> : null}
                       valid={props.disabled || !validationData?.validationMessage}
                       onBlur={handleBlur}
                       onKeyUp={handleKeyUp}/>
        {!props.disabled && validationData?.validationMessage != null && <Error>{validationData.validationMessage}</Error>}
    </div>)
}

export interface flintNumericTextBoxProps extends NumericTextBoxProps {
    onEnterPressed?: KeyboardEventHandler,
    wrappedSuffix?: ReactNode;
    validationData?: {
        validationMessage?: string | undefined,
        validateFunction?: (objectToValidate?: any) => Promise<void>,
        optionalObjectToValidate?: any
    }
}